import {
    Card,
    CardContent,
    CardHeader,
    CardTitle,
} from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { Info } from 'lucide-react'
import { useState } from 'react'
import { Skeleton } from "@/components/ui/skeleton"
import { useTranslation } from '@/hooks/use-translation'
interface AnalyticsCardProps {
    title: string
    value: number
    prev: number
    isLoading?: boolean
    tooltip?: string
}

export const AnalyticsCard = (props: AnalyticsCardProps) => {
    const [tooltipOpen, setTooltipOpen] = useState(false)
    const { t } = useTranslation()
    
    const compareText =
    props.prev === 0
        ? `+${props.value * 100}% ${t('since yesterday')}`
        : `${props.value > props.prev ? "+" : "-"}${Math.abs(((props.value - props.prev) / props.prev) * 100).toFixed(0)}% since yesterday`;

    return (
        <Card>
            <CardHeader className='flex flex-row items-center justify-between space-y-0 pb-2'>
                <CardTitle className='text-sm font-medium'>
                    {props.title}
                </CardTitle>
                {props.tooltip && (
                    <TooltipProvider delayDuration={0}>
                        <Tooltip open={tooltipOpen} onOpenChange={setTooltipOpen}>
                            <TooltipTrigger asChild>
                                <Button 
                                    variant='ghost' 
                                    size='icon' 
                                    className='h-8 w-8 p-0'
                                    onClick={() => setTooltipOpen(!tooltipOpen)}
                                >
                                    <Info className='h-4 w-4 text-muted-foreground' />
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent side='top'>
                                {props.tooltip}
                            </TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                )}
            </CardHeader>
            <CardContent>
                <div className='text-2xl font-bold'>{props.isLoading ? <Skeleton className="h-4 w-[150px] mb-2" /> : props.value}</div>
                {props.isLoading
                ? <Skeleton className="h-4 w-[150px]" />
                : <p className='text-xs text-muted-foreground'>{compareText}</p>
                }
                
            </CardContent>
        </Card>
    )
}